<template>
  <div class="card" v-if="!isDocumentViewerVisible">
    <h3
      class="p-6"
      v-if="rol !== 'supervisor' && rol !== 'consultas departamentales'"
    >
      {{
        nombre_recinto_penitenciario === "TODOS" ? "" : "CENTRO PENITENCIARIO: "
      }}
      {{
        nombre_recinto_penitenciario === "TODOS"
          ? "TODOS LOS RECINTOS"
          : nombre_recinto_penitenciario
      }}
      -
      {{
        departamento_centro_penitenciario === "NACIONAL"
          ? "NIVEL NACIONAL"
          : departamento_centro_penitenciario
      }}
    </h3>
    <h3
      class="p-10"
      v-else-if="rol === 'supervisor' || rol === 'consultas departamentales'"
    >
      SUPERVISIÓN: {{ departamento_supervisar }}
    </h3>
    <div class="card-header border-0 pt-6">
      <!-- botones -->
      <div class="card-toolbar">
        <!--botón agregar nueva ppl-->
        <div class="col-md-8 col-sm-12">
          <div
            v-if="
              rol !== 'consultas nacional' &&
              rol !== 'consultas departamentales'
            "
            class="btn-group dropend"
          >
            <buttonNewManualRegistration></buttonNewManualRegistration>
          </div>
          <!-- boton graficar -->
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="btn-group dropend">
            <button
              type="button"
              class="btn btn-success dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              :disabled="
                disabledButtonGraf === 0 || disabledButtonGrafGroup === false
              "
            >
              Graficar
            </button>
            <ul class="dropdown-menu">
              <li>
                <a
                  class="dropdown-item"
                  type="button"
                  @click="getSelectedData(1)"
                  >Barras</a
                >
              </li>
              <li>
                <a
                  class="dropdown-item"
                  type="button"
                  @click="getSelectedData(2)"
                  >Torta</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- tabla de datos -->
    <div class="card-body pt-0 dropright">
      <DxDataGrid
        id="gridContainer"
        ref="dataGridRef"
        :data-source="listPpl"
        key-expr="id_persona"
        :allow-column-reordering="false"
        :row-alternation-enabled="false"
        :show-borders="true"
        @exporting="onExporting"
        @row-prepared="onRowPrepared"
        @selection-changed="onSelectionChanged"
        @content-ready="onContentReady"
      >
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />
        <DxPager
          :visible="true"
          :allowed-page-sizes="pageSizes"
          :show-page-size-selector="true"
        />
        <DxPaging :page-size="10" />
        <DxGroupPanel :visible="true" />
        <DxGrouping :auto-expand-all="false" />
        <DxExport :enabled="true" :allow-export-selected-data="true" />
        <DxSelection mode="multiple" show-check-boxes-mode="always" />
        <DxColumn
          :width="valueAcciones"
          :allow-sorting="false"
          caption="Acciones"
          cell-template="cellTemplate"
        />
        <template #cellTemplate="{ data }">
          <!-- cargar ordenes judiciales -->
          <button
            v-if="
              data.data.documento_respaldo == null &&
              (rol !== 'consultas nacional' ||
                rol !== 'consultas departamentales')
            "
            type="button"
            class="btn px-3"
            @click="uploadResolution(data.data.id_ordenes_judiciales_ppl)"
          >
            <i
              title="Subir resolución"
              style="font-size: 1.5em; color: teal"
              class="fas fa-upload"
            ></i>
          </button>
          <input
            v-if="
              data.data.documento_respaldo == null &&
              (rol !== 'consultas nacional' ||
                rol !== 'consultas departamentales')
            "
            :id="data.data.id_ordenes_judiciales_ppl"
            type="file"
            ref="file"
            @change="handleFileUpload($event, data.data)"
            accept="application/pdf"
            hidden
          />
          <!-- ver resoluciones -->
          <button
            v-if="data.data.documento_respaldo != null"
            type="button"
            class="btn px-3"
            @click="printResolution(data.data.id_ordenes_judiciales_ppl)"
          >
            <i
              title="Ver resolución"
              style="font-size: 1.5em; color: green"
              class="fas fa-eye"
            ></i>
          </button>
          <!-- imprimir kardex -->
          <button
            type="button"
            class="btn px-3"
            @click="viewDocument('kardex', data.data.id_persona)"
          >
            <i
              title="Reimprimir kardex"
              style="font-size: 1.5em; color: skyblue"
              class="fas fa-print"
            ></i>
          </button>
          <!-- eliminar orden judicial -->
          <button
            v-if="
              data.data.documento_respaldo != null &&
              (rol === 'admin' || rol === 'editor')
            "
            type="button"
            class="btn px-3"
            @click="deleteResolution(data.data)"
          >
            <i
              title="Eliminar Resolución"
              style="font-size: 1.5em; color: indianred"
              class="fas fa-file-circle-xmark"
            ></i>
          </button>
          <!-- editar datos -->
          <button
            type="button"
            class="btn px-3"
            v-if="rol === 'admin' || rol === 'editor'"
            @click="EditData(data.data)"
          >
            <i
              title="Editar información del privado de libertad"
              style="font-size: 1.5em; color: silver"
              class="fas fa-edit"
            ></i>
          </button>
          <!-- cargar fotos de huellas dactilares -->
          <button
            v-if="!data.data.imagen_huellas"
            type="button"
            class="btn px-3"
            @click="uploadFingerPrint(data.data)"
          >
            <i
              title="Capturar huellas dactilares"
              style="font-size: 1.5em; color: gold"
              class="fas fa-fingerprint"
            ></i>
          </button>
          <!-- ver fotos de huellas dactilares -->
          <button
             v-if="data.data.imagen_huellas"
            type="button"
            class="btn px-3"
          >
           <img 
           src="../../../public/fingerprintok.png"
           width="50" height="40"
            title="Las huellas dactilares están almacenadas correctamente"
           >
          </button>
          <!-- ver huellas dactilares -->
          <!-- <button
            v-if="data.data.imagen_huellas != null && rol === 'admin'"
            type="button"
            class="btn px-3"
            @click="viewFingerPrints(data.data.id_persona)"
          >
            <i
              title="Ver huellas dactilares"
              style="font-size: 1.5em; color: green"
              class="fas fa-thumbs-up"
            ></i>
          </button> -->
          <!-- eliminar imagen de huellas dactilares -->
          <!-- <button
            v-if="data.data.imagen_huellas != null && rol === 'admin'"
            type="button"
            class="btn px-3"
            @click="deleteFingerPrints(data.data)"
          >
            <i
              title="Eliminar Resolución"
              style="font-size: 1.5em; color: indianred"
              class="fas fa-eraser"
            ></i>
          </button> -->
          <!-- agregar mandamientos -->
          <button
            v-if="
              !data.data.sw_traslado_salida &&
              (rol !== 'consultas nacional' ||
                rol !== 'consultas departamentales')
            "
            type="button"
            class="btn px-3 btn-lg dropdown-toggle"
            aria-haspopup="true"
            aria-expanded="false"
            @click="openModal(data.data)"
          >
            <!-- data-bs-toggle="dropdown" -->
            <i
              title="Agregar orden judicial o registrar traslado o salida"
              style="font-size: 1.5em; color: gray"
              class="fas fa-plus-circle"
            ></i>
          </button>
          <span
            v-if="rol == 'admin' && (data.data.requiere_parentesco_victima && !data.data.nombre_parentesco)"
            title="Requiere actualizar datos, presione para continuar"
            @click="updatePosibleRelationship(data.data)"
            > <button
                type="button"
                class="btn px-3"
              >
              <img 
              src="../../../public/update_user.png"
              width="30" height="30"
              >
              </button>
            </span>
          <!-- <ul class="dropdown-menu">
            <li>
              <a
                class="dropdown-item"
                @click="check_exist_and_add_order(data.data)"
                ><i
                  style="font-size: 1em; color: purple"
                  class="fas fa-plus"
                ></i>
                Agregar Orden Judicial</a
              >
            </li>
            <li>
              <a class="dropdown-item" @click="addOrder(data.data, 'traslados')"
                ><i
                  style="font-size: 1em; color: skyblue"
                  class="fas fa-arrow-right-arrow-left"
                ></i>
                Traslados</a
              >
            </li>
            <li>
              <a class="dropdown-item" @click="addOrder(data.data, 'salidas')"
                ><i
                  style="font-size: 1em; color: blue"
                  class="fas fa-arrow-right-from-bracket"
                ></i>
                Salidas</a
              >
              <span class="caret"></span>
            </li>
          </ul> -->
          <!-- alerta sentenciados -->
          <span
            v-if="alertaSentenciados(data.data)"
            class="badge badge-pill badge-danger transicion"
            :title="`El día ${DateFormat(
              new Date(data.data.fecha_salida_sentencia)
            )} corresponde a la fecha de salida según mandamiento de condena.`"
            >ATENCIÓN</span
          >
          <!-- alerta preventivos -->
          <!-- <span
            v-if="alertaPreventivos(data.data)"
            class="badge badge-pill badge-warning transicion_preventivos"
            :title="`Desde el día ${DateFormat(
              new Date(data.data.fecha_ingreso_recinto)
            )}, ya pasaron 6 meses de detención preventiva.`"
            >ATENCIÓN</span
          > -->
        </template>
        <DxColumn
          :width="170"
          data-field="codigo_file_ppl"
          :allow-grouping="false"
          caption="Código file PPL"
        />
        <DxColumn :width="170" data-field="nombres" :allow-grouping="false" />
        <DxColumn
          :width="170"
          data-field="primer_apellido"
          :allow-grouping="false"
        />
        <DxColumn
          :width="170"
          data-field="segundo_apellido"
          :allow-grouping="false"
        />
        <DxColumn
          :width="285"
          data-field="nombre_tipo_documento_identidad"
          caption="Tipo documento de identidad"
        />
        <DxColumn
          :width="250"
          data-field="nro_documento"
          :allow-grouping="false"
          caption="Nro. documento de identidad"
        />
        <DxColumn
          :width="100"
          data-field="complemento"
          caption="Comp."
          :allow-grouping="false"
        />
        <DxColumn
          :width="200"
          data-field="fecha_nacimiento"
          data-type="date"
          :format="DateFormat"
        />
        <DxColumn :width="100" data-field="genero" />
        <DxColumn
          :width="130"
          data-field="nombre_estado_civil"
          caption="Estado civil"
        />
        <DxColumn :width="100" data-field="pais" caption="País" />
        <DxColumn
          :width="130"
          data-field="dep_nacimiento"
          caption="Departamento"
        />
        <DxColumn
          :width="200"
          data-field="nombre_recinto_penitenciario"
          caption="Centro Penitenciario"
        />
        <DxColumn
          :width="270"
          data-field="recinto_departamento"
          caption="Departamento centro penitenciario"
        />
        <DxColumn
          :width="450"
          data-field="descripcion_delito"
          caption="Delito"
        />
        <DxColumn
          :width="200"
          data-field="tipo_mandamiento"
          caption="Situación Jurídica"
        />
        <DxColumn
          :width="150"
          data-field="anios_sentencia"
          caption="Años sentencia"
        />
        <DxColumn
          :width="150"
          data-field="meses_sentencia"
          caption="Meses sentencia"
        />
        <DxColumn
          :width="250"
          data-field="fecha_ingreso_recinto"
          data-type="date"
          :format="DateFormat"
          caption="Fecha de ingreso al recinto"
        />
        <DxColumn
          :width="300"
          :allow-sorting="false"
          caption="Tiempo Transcurrido"
          cell-template="templateTiempoTranscurrido"
        />
        <template #templateTiempoTranscurrido="{ data }">
          <span style="text-transform: uppercase">
            {{ calcularTiempoTranscurrido(data.data.fecha_ingreso_recinto) }}
          </span>
        </template>
        <DxColumn
          :width="300"
          :allow-sorting="false"
          caption="Tiempo Restante"
          cell-template="templateTiempoRestante"
        />
        <template #templateTiempoRestante="{ data }">
          <span style="text-transform: uppercase">
            {{ calcularTiempoRestante(data.data.fecha_salida_sentencia) }}
          </span>
        </template>
        <DxColumn
          :width="210"
          data-field="fecha_salida_sentencia"
          data-type="date"
          :format="DateFormat"
          caption="Fecha salida según sentencia"
        />
        <DxColumn
          :width="300"
          data-field="nombre_completo_juez"
          caption="Nombre del juez"
        />
        <DxColumn :width="600" data-field="nombre_juzgado" caption="Juzgado" />
        <DxColumn
          :width="200"
          data-field="nombre_grado_profesion"
          caption="Profesión"
        />
        <DxColumn :width="150" data-field="nombre_oficio" caption="Oficio" />
        <DxColumn
          :width="200"
          data-field="nombre_grado_instruccion"
          caption="Grado de instrucción"
        />
        <DxColumn
          :width="150"
          data-field="nombre_identificacion_etnica"
          caption="Identidad étnica"
        />
        <DxColumn
          :width="150"
          data-field="nombre_orientacion_sexual"
          caption="Identidad sexual"
        />
        <DxColumn
          :width="150"
          data-field="nombre_religion"
          caption="Religión"
        />
        <DxColumn
          :width="200"
          data-field="nombre_parentesco"
          caption="Relación Posible victima"
        />
        <DxColumn
          :width="200"
          data-field="nombre_relacion_no_aplica"
          caption="Otra relación"
        />
        <DxColumn
          :width="250"
          data-field="usuario_nombre"
          caption="Nombre filiador"
        />
        <DxGroupPanel :visible="true" />
        <DxSearchPanel :visible="true" :highlight-case-sensitive="true" />
        <DxSummary>
          <DxGroupItem
            column="recinto_departamento"
            summary-type="count"
            display-format="{0} Persona(s) Privada de Libertad"
          />
          <DxTotalItem
            column="id_persona"
            summary-type="count"
            display-format="Total count: {0} Personas privadas de libertad"
          />
        </DxSummary>
        <DxSortByGroupSummaryInfo summary-item="primer_apellido" />
      </DxDataGrid>
    </div>
  </div>
  <!--chart de barras de un grupo seleccionado  -->
  <DxChart
    v-if="chartStatus == 'one' && typeChart == 'barras'"
    id="chart"
    palette="Soft"
    :data-source="chartDataValues"
    title="Sistema de Régimen Penitenciario"
  >
    <DxSeriesTemplate name-field="nombre" />
    <DxCommonSeriesSettings
      :ignore-empty-points="true"
      argument-field="nombre"
      value-field="count"
      type="bar"
    >
      <DxLabel :visible="true" background-color="#c18e92" />
    </DxCommonSeriesSettings>
    <DxArgumentAxis :tick-interval="200" title="">
      <DxLabel :rotation-angle="80" display-mode="rotate" />
    </DxArgumentAxis>
    <DxValueAxis
      value-type="numeric"
      type="discrete"
      :tick-interval="1000"
      title="Número de PPL"
    ></DxValueAxis>
    <DxLegend :visible="false" />
    <DxExport :enabled="true" />
    <DxTooltip
      :enabled="true"
      :customize-tooltip="customizeTooltip1"
      location="edge"
    />
  </DxChart>
  <!-- chart de barras de dos grupos seleccionados -->
  <DxChart
    v-if="chartStatus == 'two' && typeChart == 'barras'"
    id="chart1"
    palette="Soft"
    :data-source="chartDataTwoParams.dataBars"
    title="Sistema de régimen penitenciario"
  >
    <DxSeriesTemplate name-field="data1" />
    <DxCommonSeriesSettings
      :ignore-empty-points="true"
      argument-field="data2"
      value-field="count"
      type="bar"
    >
      <DxLabel :visible="true" background-color="#c18e92" />
    </DxCommonSeriesSettings>
    <DxArgumentAxis :tick-interval="500" title="">
      <DxLabel :rotation-angle="-80" display-mode="rotate" />
    </DxArgumentAxis>
    <DxValueAxis
      value-type="numeric"
      type="discrete"
      :tick-interval="1000"
      title="Número de PPL"
    ></DxValueAxis>
    <DxTooltip
      :enabled="true"
      :customize-tooltip="customizeTooltip"
      location="edge"
    />
    <DxExport :enabled="true" />
    <DxZoomAndPan argument-axis="both" value-axis="both" />
    <DxLegend
      :visible="true"
      vertical-alignment="bottom"
      horizontal-alignment="center"
    />
  </DxChart>
  <!-- chart en torta de un grupo seleccionado  -->
  <DxPieChart
    v-if="chartStatus == 'one' && typeChart == 'torta'"
    id="pie"
    :data-source="chartDataValues"
    palette="Bright"
    title="Sistema de Régimen Penitenciario"
    @point-click="pointClickHandler($event)"
    @legend-click="legendClickHandler($event)"
  >
    <DxSeries argument-field="nombre" value-field="count">
      <DxLabel :visible="true">
        <DxConnector :visible="true" :width="1" />
      </DxLabel>
    </DxSeries>
    <DxTooltip
      :enabled="true"
      :customize-tooltip="customizeTooltipPie"
      location="edge"
    />
    <DxZoomAndPan argument-axis="both" value-axis="both" />
    <DxExport :enabled="true" />
  </DxPieChart>
  <!-- chart en torta de dos grupos seleccionados -->
  <DxPieChart
    v-if="chartStatus == 'two' && typeChart == 'torta'"
    id="pie"
    :data-source="chartDataTwoParams.data1"
    :inner-radius="0.2"
    type="doughnut"
    palette="Ocean"
    @point-click="pointClickHandler($event)"
    @legend-click="legendClickHandler($event)"
  >
    <DxTitle text="Sistema de Régimen Penitenciario"> </DxTitle>
    <DxZoomAndPan argument-axis="both" value-axis="both" />
    <DxLegend :visible="true" />
    <DxExport :enabled="true" />
    <DxCommonSeriesSettings>
      <DxLabel :visible="true">
        <DxConnector :visible="true" :width="1" />
      </DxLabel>
    </DxCommonSeriesSettings>
    <DxTooltip
      :enabled="true"
      location="edge"
      :customize-tooltip="customizeTooltipPie2"
    />
    <template
      v-for="(item, key, index) in chartDataTwoParams.data2"
      :key="index"
    >
      <DxSeries
        :name="item.data2"
        argument-field="nombre"
        :value-field="item.data2"
      />
    </template>
  </DxPieChart>
  <!-- <DxSeries name="data2" argument-field="nombre" value-field="data2" />
    <DxSeries name="data1" argument-field="nombre" value-field="data1" /> -->
  <!-- loader -->
  <loading
    v-model:active="isLoading"
    :can-cancel="false"
    :is-full-page="true"
    loader="bars"
    :height="100"
    :width="100"
  ></loading>
    <documentViewer v-if="isDocumentViewerVisible" :documentType="documentType" :documentId="documentId" @close="isDocumentViewerVisible = false"></documentViewer>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { defineComponent, ref, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import filiation from "@/filiation/composables/useFiliation";
import useAuth from "@/auth/composables/useAuth";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages } from "devextreme/localization";
import { useRouter } from "vue-router";
import formatDate from "@/helpers/formatDate";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { formatDistance, addMonths, subMonths } from "date-fns";
import { es } from "date-fns/esm/locale";
import buttonNewManualRegistration from "@/views/buttons/buttonNewManualRegistration.vue";
import documentViewer from "@/views/documentViewer.vue"
import {
  DxDataGrid,
  DxFilterRow,
  DxColumn,
  DxExport,
  DxSelection,
  DxGroupPanel,
  DxGrouping,
  DxSearchPanel,
  DxPaging,
  DxPager,
  DxSummary,
  DxGroupItem,
  DxSortByGroupSummaryInfo,
  //DxButton,
  DxTotalItem,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import DxChart, {
  DxValueAxis,
  DxArgumentAxis,
  DxLegend,
  DxLabel,
  DxSeriesTemplate,
  DxCommonSeriesSettings,
  DxTooltip,
  DxZoomAndPan,
} from "devextreme-vue/chart";
import DxPieChart, {
  DxSeries,
  DxConnector,
  DxTitle,
} from "devextreme-vue/pie-chart";
import "devextreme/dist/css/dx.light.css";
export default defineComponent({
  name: "private-liberty-list",
  components: {
    DxDataGrid,
    DxFilterRow,
    DxColumn,
    DxExport,
    DxSelection,
    DxGroupPanel,
    DxGrouping,
    DxSearchPanel,
    DxPaging,
    DxPager,
    DxSummary,
    DxGroupItem,
    DxSortByGroupSummaryInfo,
    DxTotalItem,
    DxHeaderFilter,

    DxChart,
    DxValueAxis,
    DxArgumentAxis,
    DxLabel,
    DxLegend,
    DxTooltip,
    DxZoomAndPan,
    DxSeriesTemplate,
    DxCommonSeriesSettings,

    DxPieChart,
    DxSeries,
    DxConnector,
    DxTitle,

    Loading,
    buttonNewManualRegistration,
    documentViewer
  },
  setup() {
    loadMessages(esMessages);
    locale(navigator.language);
    const isAdmin = ref(false);
    const isEditor = ref(false);
    const file = ref(null);
    const fingerFile = ref(null);
    const sentencia_cumplida = ref(false);
    const pageSizes = ref([10, 25, 50, 100]);
    let isLoading = ref(false);
    const isDocumentViewerVisible =ref(false)
    const documentType =ref("")
    const documentId=ref("")
    let dataGridRef = ref();
    let selectedRowsData = [];
    let colCount = ref(0);
    let colNames = [];
    let dataValuesFiltered = [];
    let typeChart = ref("");
    const listPpl = ref([]);
    const newRegister = () => {
      router.push({
        name: "registerForm",
        params: {
          id_persona: 0,
          id_orden_judicial: 0,
        },
      });
    };
    // subir archivos inicio
    const handleFileUpload = async (event, id) => {
      file.value = event.target.files[0];
      const { data } = await uploadFile([
        file.value,
        id.id_ordenes_judiciales_ppl,
      ]);
      if (data.ok == true) {
        Swal.fire({
          title: "Archivo cargado correctamente",
          text: "El archivo pdf de la resolución fue registrado exitosamente.",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
        await pplList();
      } else {
        Swal.fire({
          title: "Error",
          text: "El archivo no pudo ser cargado.",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      }
    };
    const uploadResolution = (e) => {
      document.getElementById(e).click();
    };
    
    const uploadFingerPrint = async (e) => {
      router.push({
        name:"uploadFingerPrint",
        params: { id_persona: e.cod_persona, 
                  nombre_ppl: `${e.nombres} ${e.primer_apellido} ${e.segundo_apellido}`
      },
      })
    };
    const pointClickHandler = (e) => {
      toggleVisibility(e.target);
    };
    const legendClickHandler = (e) => {
      const arg = e.target;
      const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];

      toggleVisibility(item);
    };
    const toggleVisibility = (item) => {
      item.isVisible() ? item.hide() : item.show();
    };
    const DateFormat = (date) => {
      const formattedDate = formatDate(date);
      return formattedDate;
    };
    const {
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      id_recinto,
    } = useAuth();
    const {
      PrivateLibertyList,
      kardex,
      uploadFile,
      uploadFingerFile,
      resolution,
      viewFingers,
      deleteFile,
      deleteFingerPrint,
      chartData,
      chartDataValues,
      chartDataTwoParams,
      chartStatus,
      passData,
      relationships,
    } = filiation();
    const valueAcciones = computed(() => {
      if (
        rol.value === "consultas nacional" ||
        rol.value === "consultas departamental"
      ) {
        return 250;
      } else {
        return 650;
      }
    });
    const router = useRouter();
    const NewRegister = () => {
      router.push({ name: "registerForm" });
    };
    const pplList = async () => {
      isLoading.value = true;
      const { data } = await PrivateLibertyList({
        id_recinto,
        departamento_supervisar,
      });
      listPpl.value = data;
      isLoading.value = false;
    };
    const calcularTiempoTranscurrido = (fecha_ingreso) => {
      const fecha_actual = new Date();
      return `Recluido ${formatDistance(new Date(fecha_ingreso), fecha_actual, {
        addSuffix: true,
        locale: es,
      })}`;
    };
    const calcularTiempoRestante = (fecha_salida) => {
      const fecha_actual = new Date();
      if (fecha_salida == null) {
        return;
      } else if (new Date(fecha_salida) >= fecha_actual) {
        return `Cumple ${formatDistance(new Date(fecha_salida), fecha_actual, {
          addSuffix: true,
          locale: es,
        })}`;
      } else if (new Date(fecha_salida) < fecha_actual) {
        return `Cumplió ${formatDistance(new Date(fecha_salida), fecha_actual, {
          addSuffix: true,
          locale: es,
        })}`;
      }
    };
    const alertaSentenciados = (e) => {
      if (e.fecha_salida_sentencia !== null) {
        const fecha_actual = new Date();
        const fecha_salida = subMonths(new Date(e.fecha_salida_sentencia), 1);
        fecha_actual.setHours(0, 0, 0, 0);
        fecha_salida.setHours(0, 0, 0, 0);
        if (fecha_salida.getTime() <= fecha_actual.getTime()) {
          return true;
        } else {
          return false;
        }
      }
    };
    const alertaPreventivos = (e) => {
      if (
        e.tipo_mandamiento === "PREVENTIVO" &&
        e.fecha_salida_sentencia === null
      ) {
        const fecha_actual = new Date();
        const fecha_ingreso = addMonths(new Date(e.fecha_ingreso_recinto), 6);
        fecha_actual.setHours(0, 0, 0, 0);
        fecha_ingreso.setHours(0, 0, 0, 0);
        if (fecha_ingreso.getTime() <= fecha_actual.getTime()) {
          return true;
        } else {
          return false;
        }
      }
    };
    const onRowPrepared = (e) => {
      if (e.rowType === "data" && e.data.fecha_salida_sentencia !== null) {
        const fecha_actual = new Date();
        const fecha_salida = new Date(e.data.fecha_salida_sentencia);
        fecha_actual.setHours(0, 0, 0, 0);
        fecha_salida.setHours(0, 0, 0, 0);
        if (fecha_salida.getTime() <= fecha_actual.getTime()) {
          sentencia_cumplida.value = true;
        } else {
          sentencia_cumplida.value = false;
        }
      } else if (
        e.rowType === "data" &&
        e.data.fecha_salida_sentencia === null
      ) {
        const fecha_actual = new Date();
        const fecha_ingreso = addMonths(
          new Date(e.data.fecha_ingreso_recinto),
          6
        );
        fecha_actual.setHours(0, 0, 0, 0);
        fecha_ingreso.setHours(0, 0, 0, 0);
      }
    };
    const onExporting = (e) => {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("tableData");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "SirepReport.xlsx"
          );
        });
      });
      e.cancel = true;
    };
    const EditData = async (e) => {
      await passData({
        id_persona: e.id_persona,
        id_orden_judicial: e.id_ordenes_judiciales_ppl,
      });
      router.push({
        name: "registerForm",
        params: {
          id_persona: e.id_persona,
          id_orden_judicial: e.id_ordenes_judiciales_ppl,
        },
      });
    };
    // const viewDocument = async (e) => {
    //   await kardex(e);
    // };
    const viewDocument = async (type, id) => {
      isDocumentViewerVisible.value=true
      documentId.value=id;
      documentType.value=type;
      // await resolution(id);
    };
    const printResolution = async (id) => {
      await resolution(id);
    };
    const viewFingerPrints = async (id) => {
      await viewFingers(id);
    };
    const customizeTooltip = (pointInfo) => {
      return {
        text: `${pointInfo.argument} <br> ${pointInfo.seriesName} <br> ${pointInfo.valueText} persona(s) privada(s) de libertad`,
      };
    };
    const customizeTooltip1 = (pointInfo) => {
      return {
        text: `${pointInfo.seriesName} <br> ${pointInfo.valueText} persona(s) privada(s) de libertad`,
      };
    };
    const customizeTooltipPie = (pointInfo) => {
      return {
        text: `${pointInfo.argument} <br> ${pointInfo.valueText} persona(s) privada(s) de libertad (${pointInfo.percentText})`,
      };
    };
    const customizeTooltipPie2 = (pointInfo) => {
      return {
        text: `${pointInfo.seriesName}<br>${pointInfo.argumentText}<br>${pointInfo.valueText} persona(s) privadas de libertad (${pointInfo.percentText})`,
      };
    };
    const getSelectedData = async (value) => {
      if (value == 1) {
        typeChart.value = "barras";
      } else if (value == 2) {
        typeChart.value = "torta";
      }
      isLoading.value = true;
      selectedRowsData.push(dataGrid.value.getSelectedRowsData());
      for (let i = 0; i < dataGrid.value.columnCount(); i++) {
        if (dataGrid.value.columnOption(i, "groupIndex") > -1) {
          colCount.value++;
          colNames.push(dataGrid.value.columnOption(i, "dataField"));
        }
      }
      const { data } = await chartData({
        col: colNames,
        data: selectedRowsData,
      });
      data ? (isLoading.value = false) : (isLoading.value = true);
      if (data) {
        Swal.fire({
          title: "Generado",
          text: "El gráfico fue generado con éxito.",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      } else {
        isLoading.value = false;
        Swal.fire({
          title: "El gráfico no pudo ser generado",
          text: "Solo debe seleccionar hasta dos agrupaciones.",
          icon: "info",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      }
      selectedRowsData = [];
      colCount = ref(0);
      colNames = [];
      dataValuesFiltered = [];
      dataGrid.value.clearFilter();
      dataGrid.value.clearGrouping();
      dataGrid.value.clearSelection();
    };
    let disabledButtonGraf = ref(0);
    let disabledButtonGrafGroup = ref(false);
    const onSelectionChanged = ({ selectedRowKeys }) => {
      disabledButtonGraf.value = selectedRowKeys.length;
    };
    const onContentReady = async (e) => {
      var isGrouped = !!e.component.columnOption("groupIndex:0");
      isGrouped
        ? (disabledButtonGrafGroup.value = true)
        : (disabledButtonGrafGroup.value = false);
    };
    const swalWithBootstrapButtons = Swal.mixin({
      confirmButtonText: "Continuar",
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    const deleteResolution = async (dato) => {
      Swal.fire({
        title: `¿Está seguro de eliminar el archivo PDF del mandamiento de tipo ${dato.tipo_mandamiento} correspondiente a ${dato.nombres} ${dato.primer_apellido} ${dato.segundo_apellido}?`,
        text: "No podrá revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, eliminar",
        cancelButtonText: `Cancelar`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await deleteFile(dato.id_ordenes_judiciales_ppl);
          if (data.ok === true) {
            swalWithBootstrapButtons.fire(
              "¡Eliminado!",
              "El archivo fue eliminado satisfactoriamente.",
              "success"
            );
            await pplList();
          } else {
            Swal.fire({
              title: "Error",
              text: "El archivo no pudo ser eliminado.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
          }
        }
      });
    };
    const deleteFingerPrints = async (dato) => {
      Swal.fire({
        title: `¿Está seguro de eliminar la imagen de las huellas dactilares correspondiente a ${dato.nombres} ${dato.primer_apellido} ${dato.segundo_apellido}?`,
        text: "No podrá revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, eliminar",
        cancelButtonText: `Cancelar`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await deleteFingerPrint(dato.id_persona);
          if (data.ok === true) {
            swalWithBootstrapButtons.fire(
              "¡Eliminado!",
              "El archivo fue eliminado satisfactoriamente.",
              "success"
            );
            await pplList();
          } else {
            Swal.fire({
              title: "Error",
              text: "El archivo no pudo ser eliminado.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
          }
        }
      });
    };
    const addOrder = async (dato, tipo) => {
      await passData({
        id_persona: dato.id_persona,
        id_orden_judicial: dato.id_ordenes_judiciales_ppl,
        tipo: tipo,
      });
      router.push({
        name: "addOrTransferOrDeparture",
        params: {
          id_persona: dato.id_persona,
          id_orden_judicial: dato.id_ordenes_judiciales_ppl,
          tipo: tipo,
          add: "other",
        },
      });
    };
    const check_exist_and_add_order = async (info) => {
      localStorage.setItem("paraAprobar", JSON.stringify(info));
      router.push({
        name: "resume_orders",
        params: {
          tipo: "agregar",
        },
      });
    };
    const openModal = async (data) => {
      const { value: valor } = await Swal.fire({
        title: "Seleccione una opción para continuar",
        input: "select",
        confirmButtonText: "Seleccionar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        customClass: "swal-wide",
        inputOptions: {
          add_order: "Añadir Orden Judicial",
          evasion: "Registrar Evasión",
          fallecimiento: "Registrar Fallecimiento",
          salidas: "Registrar Salidas Judiciales",
          // procurador: "Registrar Salida Procurador",
          traslados: "Registrar Traslado de Recinto Penitenciario",
        },
        inputPlaceholder: "Seleccione una opción",
        showCancelButton: true,
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value) {
              resolve();
            } else {
              resolve("Debe seleccionar una opción.");
            }
          });
        },
      });
      if (valor === "add_order") {
        await check_exist_and_add_order(data);
      } else if (
        valor === "traslados" ||
        valor === "salidas" ||
        valor === "evasion" ||
        valor === "fallecimiento"
      ) {
        await addOrder(data, valor);
      }
    };
    const relationshipList = ref([]);
    const relationship = async () => {
      const { data } = await relationships();
      relationshipList.value = data;
    };
    const formDataUpdateRelationship =ref({
      id_orden_judicial_ppl:"",
      id_parentesco:"",
      otro_parentesco:""
    })
    const updatePosibleRelationship =(val)=>{
      console.log(val);
      console.log(relationshipList.value);
      //hacer modal para actualizar parentesco posible victima
    let htmlContent = `
        <label for="seleccion">Selecciona una opción:</label>
        <select id="seleccion" class="swal2-select">
      `
      relationshipList.value.forEach(item => {
        htmlContent += `<option value="${item.id_parentesco}">${item.nombre_parentesco}</option>`
      })
      htmlContent += '</select><br>'
      htmlContent += `
        <div id="otroInputContainer" style="display:none;">
          <label for="inputTexto">Escribe otra relación:</label>
          <input type="text" id="inputTexto" class="swal2-input" style="text-transform:uppercase;">
        </div>
      `;
      Swal.fire({
        title: `ACTUALIZAR RELACIÓN CON LA POSIBLE VICTIMA\n 
                Nombre PPL:<p>${val.nombres} ${val.primer_apellido} ${val.segundo_apellido}</p>\n
                Tipificación del delito: <p>${val.descripcion_delito}</p>`,
        html: htmlContent,
        focusConfirm: false,
        confirmButtonText: 'ENVIAR',
        customClass: {
          container: 'my-swal'
        },
        didOpen: () => {
          const selectElement = Swal.getPopup().querySelector('#seleccion');
          const inputContainer = Swal.getPopup().querySelector('#otroInputContainer');
          const inputElement = Swal.getPopup().querySelector('#inputTexto');

          selectElement.addEventListener('change', () => {
            const relacion = relationshipList.value.find(valor =>valor.id_parentesco===selectElement.value)
            if (relacion.nombre_parentesco === 'OTRO') {
              inputContainer.style.display = 'block';
            } else {
              inputContainer.style.display = 'none';
            }
          });
          inputElement.addEventListener('input', () => {
            inputElement.value = inputElement.value.toUpperCase();
          });
        },
        preConfirm: () => {
          const seleccion = Swal.getPopup().querySelector('#seleccion').value;
          const inputTexto = Swal.getPopup().querySelector('#inputTexto').value;
          const relacion = relationshipList.value.find(valor =>valor.id_parentesco===seleccion)
          if (!seleccion || (relacion.nombre_parentesco==='OTRO' && !inputTexto)) {
            Swal.showValidationMessage('Por favor, selecciona una opción y escribe algo');
          }
          formDataUpdateRelationship.value.id_orden_judicial_ppl=val.id_ordenes_judiciales_ppl
          formDataUpdateRelationship.value.id_parentesco = seleccion
          formDataUpdateRelationship.value.otro_parentesco = inputTexto
          console.log(formDataUpdateRelationship.value);
          return { seleccion: seleccion, inputTexto: inputTexto, valor: val.id_ordenes_judiciales_ppl };
        }
      }).then((result) => {
      console.log(result);
        if (result.isConfirmed) {
          const { seleccion, inputTexto, valor } = result.value;
          Swal.fire(`Seleccionaste: ${seleccion}\nEscribiste: ${inputTexto} \nen valor : ${valor}`);
        }
      });
    }
    const dataGrid = computed(() => {
      return dataGridRef.value.instance;
    });
    onMounted(() => {
      setCurrentPageBreadcrumbs("Lista general de privados de libertad", [
        "Listas",
      ]);
      pplList();
      relationship();
      const userLogged = localStorage.getItem("roles").split(",");
      for (let rol of userLogged) {
        if (rol.toUpperCase() === "ADMIN") {
          isAdmin.value = true;
        } else if (rol.toUpperCase() === "EDITOR") {
          isEditor.value = true;
        }
      }
    });
    return {
      valueAcciones,
      isAdmin,
      isEditor,
      file,
      fingerFile,
      isLoading,
      isDocumentViewerVisible,
      dataGridRef,
      dataGrid,
      selectedRowsData,
      colCount,
      colNames,
      dataValuesFiltered,
      listPpl,
      pageSizes,
      sentencia_cumplida,
      typeChart,
      chartDataValues,
      chartDataTwoParams,
      chartStatus,
      disabledButtonGraf,
      disabledButtonGrafGroup,
      newRegister,
      onSelectionChanged,
      onContentReady,
      uploadResolution,
      handleFileUpload,
      viewDocument,
      viewFingerPrints,
      alertaPreventivos,
      alertaSentenciados,
      pointClickHandler,
      legendClickHandler,
      toggleVisibility,
      calcularTiempoTranscurrido,
      calcularTiempoRestante,
      onRowPrepared,
      deleteResolution,
      deleteFingerPrints,
      NewRegister,
      addOrder,
      check_exist_and_add_order,
      pplList,
      EditData,
      uploadFingerPrint,
      DateFormat,
      onExporting,
      getSelectedData,
      customizeTooltip,
      customizeTooltip1,
      customizeTooltipPie,
      customizeTooltipPie2,
      openModal,
      updatePosibleRelationship,
      printResolution,
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      id_recinto,
      documentId,
      documentType,
    };
  },
});
</script>
<style>
.transicion {
  animation: parpadeo 2s infinite;
}
@keyframes parpadeo {
  0% {
    background-color: rgb(209, 205, 205);
    color: black;
  }
  50% {
    background-color: red;
    color: aliceblue;
  }
  100% {
    background-color: rgb(209, 205, 205);
    color: black;
  }
}
.transicion_preventivos {
  animation: parpadeo_preventivos 2s infinite;
}
@keyframes parpadeo_preventivos {
  0% {
    background-color: rgb(226, 226, 189);
    color: grey;
  }
  50% {
    background-color: yellow;
    color: black;
  }
  100% {
    background-color: rgb(226, 226, 189);
    color: grey;
  }
}
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}
.tooltip .tiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 3px;
  padding: 6px 0;
  position: absolute;
  z-index: 1;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}
.tooltip .tiptext::after {
  content: "";
  position: absolute;
  border-width: 5px;
  border-style: solid;
}
.tooltip:hover .tiptext {
  visibility: visible;
}
#chart {
  height: 1000px;
  width: 100%;
}
#chart1 {
  height: 1000px;
  width: 100%;
}
#pie {
  height: 700px;
  width: 100%;
}
.swal-wide {
  width: 500px !important;
}
.swal2-select {
  display: block;
  width: 100%;
  font-size: 1rem;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.my-swal .swal2-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.my-swal .swal2-popup {
  width: 50% !important; /* Ajusta el ancho del modal según tus necesidades */
  max-width: none !important; /* Para que el modal respete el ancho personalizado */
}

</style>
